 const getBaseURL = () => {     const currentHost = window.location.hostname; 
    if (currentHost.startsWith('www.')) {
        return 'https://chenillemuebles.com/';
    } else {
        return 'https://chenillemuebles.com/';
    }
    
};

const baseURL = getBaseURL(); 

export default baseURL;

